import React from "react";
import { Link } from "react-router-dom";

export const WorkbookHero = () => {
  return (
    <>
      {/* SECTION 1: HERO */}
      <section className="bg-[#F5E9EC] py-10 md:py-20 w-full border-b border-[#E8DEC8]">
        <div className="w-full px-4 sm:px-8 lg:px-16 max-w-[1600px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
            <div className="lg:col-span-6 space-y-5">
              <span className="text-xs text-[#9E1B50] uppercase font-bold tracking-[0.2em] block">
                THE PHYSICAL WORKBOOK
              </span>
              <h1 className="font-serif text-3xl sm:text-5xl lg:text-6xl font-normal text-[#380C1E] leading-[1.1]">
                From Burnout to{" "}
                <span className="italic font-serif">Becoming.</span>
              </h1>

              {/* Mobile: book image beside the CTAs */}
              <div className="grid grid-cols-5 lg:grid-cols-1 gap-4 lg:gap-0 items-center">
                <div className="col-span-2 lg:hidden flex justify-center">
                  <img
                    src="https://vibe.filesafe.space/1784937135036191007/attachments/dd434134-7119-4daf-be69-edf4d039f7bb.png"
                    alt="From Burnout to Becoming workbook by Ieshia Danielle, 64 guided pages"
                    className="w-full max-w-[150px] aspect-square object-contain drop-shadow-xl"
                  />
                </div>

                <div className="col-span-3 lg:col-span-1 space-y-3">
                  <div className="flex items-baseline gap-2">
                    <span className="font-serif text-2xl md:text-4xl font-semibold text-[#380C1E]">
                      $27
                    </span>
                    <span className="text-[10px] md:text-xs font-semibold uppercase tracking-wider text-[#380C1E]/60">
                      +SHIPPING
                    </span>
                  </div>
                  <p className="hidden lg:block text-[11px] text-[#380C1E]/70 font-light">
                    Licensed for personal use only. Full license:{" "}
                    <Link
                      to="/product-license"
                      className="underline hover:text-[#9E1B50]"
                    >
                      iamieshiadanielle.com/product-license
                    </Link>
                  </p>
                  <a
                    href="https://store.iamieshiadanielle.com/product-details/product/from-burnout-to-becoming-purpose-workbook-for-moms"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full bg-[#9E1B50] hover:bg-[#801440] text-white font-bold uppercase text-[10px] md:text-[11px] tracking-wider py-3 md:py-4 rounded-xl flex items-center justify-between px-3 md:px-6 transition-all"
                  >
                    <span>ADD TO CART · $27</span>
                    <span>→</span>
                  </a>
                  <a
                    href="https://store.iamieshiadanielle.com/product-details/product/6a86712d71e03b860a5c7a77"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full bg-[#4A0E26] hover:bg-[#380C1E] text-white font-bold uppercase text-[10px] md:text-[11px] tracking-wider py-3 md:py-4 rounded-xl flex items-center justify-between px-3 md:px-6 transition-all"
                  >
                    <span>DIGITAL · $15</span>
                    <span>→</span>
                  </a>
                  <a
                    href="https://quiz.iamieshiadanielle.com/quiz"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full bg-[#EFE6D2]/60 hover:bg-[#EFE6D2] text-[#380C1E] font-bold uppercase text-[10px] md:text-[11px] tracking-wider py-3 md:py-3.5 rounded-xl flex items-center justify-between px-3 md:px-6 transition-all border border-[#E8DEC8]"
                  >
                    <span>TAKE THE QUIZ</span>
                    <span>→</span>
                  </a>
                </div>
              </div>
            </div>

            {/* Desktop: book image on the right */}
            <div className="hidden lg:flex lg:col-span-6 items-center justify-center">
              <img
                src="https://vibe.filesafe.space/1784937135036191007/attachments/dd434134-7119-4daf-be69-edf4d039f7bb.png"
                alt="From Burnout to Becoming workbook by Ieshia Danielle, 64 guided pages"
                className="w-full max-w-md aspect-square object-contain drop-shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 2: Join the Becoming Intensive Banner */}
      <section className="bg-[#4A0E26] text-white py-10 md:py-14 w-full">
        <div className="w-full px-4 sm:px-8 lg:px-16 max-w-[1600px] mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="space-y-1 text-center md:text-left">
            <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-white/70 block">
              WANT THE FULL GUIDED EXPERIENCE?
            </span>
            <h2 className="font-serif text-3xl md:text-5xl font-normal text-white">
              Join the Becoming{" "}
              <span className="italic font-serif">Intensive.</span>
            </h2>
          </div>
          <Link
            to="/programs/becoming-intensive"
            className="bg-white hover:bg-[#FAF6F0] text-[#4A0E26] font-bold uppercase text-[11px] tracking-wider px-8 py-3.5 rounded-full inline-flex items-center gap-2 transition-all whitespace-nowrap"
          >
            TELL ME MORE →
          </Link>
        </div>
      </section>
    </>
  );
};
